// src/appInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const env = import.meta.env.VITE_MODE;

const connectionString =
  env === 'prod'
    ? 'InstrumentationKey=9bdf8f8f-fcb2-4037-ab7c-860f079069db;IngestionEndpoint=https://brazilsouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://brazilsouth.livediagnostics.monitor.azure.com/;ApplicationId=11a861dd-f1e9-40ae-a343-5f544217b4b1'
    : 'InstrumentationKey=499e87f0-0a5c-4a5b-87a4-5ceb8b1709c5;IngestionEndpoint=https://brazilsouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://brazilsouth.livediagnostics.monitor.azure.com/;ApplicationId=4507a56b-acf7-492a-a173-8d8752fe60fd';


const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    disablePageUnloadEvents: ['unload'],
  },
});

appInsights.loadAppInsights();

export default appInsights;
